/* shop/components/Basket.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	component_subscribe,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prop_dev,
	run_all,
	safe_not_equal,
	set_data_dev,
	set_style,
	space,
	src_url_equal,
	text,
	validate_each_argument,
	validate_slots,
	validate_store
} from "svelte/internal";

import basketStore, {
	basketItemsCount,
	basketPrice,
	basketQuantity,
	basketDiscount,
	isDiscountActive
} from "./../basketStore";

import basketImage from "./../basket.svg";
const file = "shop/components/Basket.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (99:0) {:else}
function create_else_block(ctx) {
	let p;

	const block = {
		c: function create() {
			p = element("p");
			p.textContent = "Váš košík je prázdný";
			attr_dev(p, "class", "basketInfoEmpty");
			add_location(p, file, 99, 4, 3508);
		},
		m: function mount(target, anchor) {
			insert_dev(target, p, anchor);
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(p);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_else_block.name,
		type: "else",
		source: "(99:0) {:else}",
		ctx
	});

	return block;
}

// (39:0) {#if $basketItemsCount > 0}
function create_if_block(ctx) {
	let div;
	let table;
	let thead;
	let tr;
	let th0;
	let t1;
	let th1;
	let t3;
	let th2;
	let t5;
	let th3;
	let t7;
	let th4;
	let t9;
	let th5;
	let t11;
	let tbody;
	let t12;
	let t13;
	let each_value = /*$basketStore*/ ctx[1].items;
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block0 = /*$basketQuantity*/ ctx[2] < /*$basketStore*/ ctx[1].quantityThreshold && /*$isDiscountActive*/ ctx[3] && /*$basketStore*/ ctx[1].unitDiscount > 0 && create_if_block_2(ctx);
	let if_block1 = /*$basketQuantity*/ ctx[2] >= /*$basketStore*/ ctx[1].quantityThreshold && /*$isDiscountActive*/ ctx[3] && /*$basketStore*/ ctx[1].unitDiscount > 0 && create_if_block_1(ctx);

	const block = {
		c: function create() {
			div = element("div");
			table = element("table");
			thead = element("thead");
			tr = element("tr");
			th0 = element("th");
			th0.textContent = "Položka";
			t1 = space();
			th1 = element("th");
			th1.textContent = "Typ";
			t3 = space();
			th2 = element("th");
			th2.textContent = "Cena";
			t5 = space();
			th3 = element("th");
			th3.textContent = "Počet";
			t7 = space();
			th4 = element("th");
			th4.textContent = "Cena celkem";
			t9 = space();
			th5 = element("th");
			th5.textContent = "Smazat z košíku";
			t11 = space();
			tbody = element("tbody");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t12 = space();
			if (if_block0) if_block0.c();
			t13 = space();
			if (if_block1) if_block1.c();
			add_location(th0, file, 43, 16, 1058);
			add_location(th1, file, 44, 16, 1091);
			add_location(th2, file, 45, 16, 1120);
			add_location(th3, file, 46, 16, 1150);
			add_location(th4, file, 47, 16, 1181);
			add_location(th5, file, 48, 16, 1218);
			add_location(tr, file, 42, 12, 1037);
			add_location(thead, file, 41, 8, 1017);
			add_location(tbody, file, 51, 8, 1286);
			attr_dev(table, "class", "uk-table basketTable ");
			add_location(table, file, 40, 4, 970);
			attr_dev(div, "class", "uk-overflow-auto");
			add_location(div, file, 39, 0, 935);
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, table);
			append_dev(table, thead);
			append_dev(thead, tr);
			append_dev(tr, th0);
			append_dev(tr, t1);
			append_dev(tr, th1);
			append_dev(tr, t3);
			append_dev(tr, th2);
			append_dev(tr, t5);
			append_dev(tr, th3);
			append_dev(tr, t7);
			append_dev(tr, th4);
			append_dev(tr, t9);
			append_dev(tr, th5);
			append_dev(table, t11);
			append_dev(table, tbody);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(tbody, null);
				}
			}

			append_dev(div, t12);
			if (if_block0) if_block0.m(div, null);
			append_dev(div, t13);
			if (if_block1) if_block1.m(div, null);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*basketStore, $basketStore*/ 2) {
				each_value = /*$basketStore*/ ctx[1].items;
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(tbody, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (/*$basketQuantity*/ ctx[2] < /*$basketStore*/ ctx[1].quantityThreshold && /*$isDiscountActive*/ ctx[3] && /*$basketStore*/ ctx[1].unitDiscount > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					if_block0.m(div, t13);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*$basketQuantity*/ ctx[2] >= /*$basketStore*/ ctx[1].quantityThreshold && /*$isDiscountActive*/ ctx[3] && /*$basketStore*/ ctx[1].unitDiscount > 0) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					if_block1.m(div, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			destroy_each(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(39:0) {#if $basketItemsCount > 0}",
		ctx
	});

	return block;
}

// (57:24) {#if item.description}
function create_if_block_3(ctx) {
	let br;
	let t0;
	let t1_value = /*item*/ ctx[7].description + "";
	let t1;
	let t2;

	const block = {
		c: function create() {
			br = element("br");
			t0 = text("(");
			t1 = text(t1_value);
			t2 = text(")");
			add_location(br, file, 57, 28, 1516);
		},
		m: function mount(target, anchor) {
			insert_dev(target, br, anchor);
			insert_dev(target, t0, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, t2, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2 && t1_value !== (t1_value = /*item*/ ctx[7].description + "")) set_data_dev(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(br);
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(t2);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(57:24) {#if item.description}",
		ctx
	});

	return block;
}

// (53:12) {#each $basketStore.items as item}
function create_each_block(ctx) {
	let tr;
	let td0;
	let strong;
	let t0_value = /*item*/ ctx[7].title + "";
	let t0;
	let t1;
	let t2;
	let td1;

	let t3_value = (/*item*/ ctx[7].book_type == 'PRINT'
	? 'tištěná'
	: 'ekniha') + "";

	let t3;
	let t4;
	let td2;
	let t5_value = /*item*/ ctx[7].unit_price.toLocaleString() + "";
	let t5;
	let t6;
	let t7;
	let td3;
	let input;
	let input_value_value;
	let t8;
	let td4;
	let t9_value = /*item*/ ctx[7].full_price.toLocaleString() + "";
	let t9;
	let t10;
	let t11;
	let td5;
	let button;
	let t13;
	let mounted;
	let dispose;
	let if_block = /*item*/ ctx[7].description && create_if_block_3(ctx);

	function change_handler(...args) {
		return /*change_handler*/ ctx[5](/*item*/ ctx[7], ...args);
	}

	function click_handler() {
		return /*click_handler*/ ctx[6](/*item*/ ctx[7]);
	}

	const block = {
		c: function create() {
			tr = element("tr");
			td0 = element("td");
			strong = element("strong");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			td1 = element("td");
			t3 = text(t3_value);
			t4 = space();
			td2 = element("td");
			t5 = text(t5_value);
			t6 = text(" Kč");
			t7 = space();
			td3 = element("td");
			input = element("input");
			t8 = space();
			td4 = element("td");
			t9 = text(t9_value);
			t10 = text(" Kč");
			t11 = space();
			td5 = element("td");
			button = element("button");
			button.textContent = "X";
			t13 = space();
			add_location(strong, file, 55, 24, 1411);
			add_location(td0, file, 54, 20, 1382);
			add_location(td1, file, 61, 20, 1620);
			add_location(td2, file, 63, 20, 1701);
			attr_dev(input, "type", "number");
			attr_dev(input, "class", "basketInput");
			input.value = input_value_value = /*item*/ ctx[7].quantity;
			attr_dev(input, "min", "1");
			add_location(input, file, 66, 24, 1803);
			add_location(td3, file, 65, 20, 1774);
			add_location(td4, file, 74, 20, 2157);
			attr_dev(button, "type", "button");
			attr_dev(button, "class", "basketDeleteItem");
			add_location(button, file, 77, 24, 2255);
			add_location(td5, file, 76, 20, 2225);
			add_location(tr, file, 53, 16, 1357);
		},
		m: function mount(target, anchor) {
			insert_dev(target, tr, anchor);
			append_dev(tr, td0);
			append_dev(td0, strong);
			append_dev(strong, t0);
			append_dev(td0, t1);
			if (if_block) if_block.m(td0, null);
			append_dev(tr, t2);
			append_dev(tr, td1);
			append_dev(td1, t3);
			append_dev(tr, t4);
			append_dev(tr, td2);
			append_dev(td2, t5);
			append_dev(td2, t6);
			append_dev(tr, t7);
			append_dev(tr, td3);
			append_dev(td3, input);
			append_dev(tr, t8);
			append_dev(tr, td4);
			append_dev(td4, t9);
			append_dev(td4, t10);
			append_dev(tr, t11);
			append_dev(tr, td5);
			append_dev(td5, button);
			append_dev(tr, t13);

			if (!mounted) {
				dispose = [
					listen_dev(input, "change", change_handler, false, false, false, false),
					listen_dev(button, "click", click_handler, false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty & /*$basketStore*/ 2 && t0_value !== (t0_value = /*item*/ ctx[7].title + "")) set_data_dev(t0, t0_value);

			if (/*item*/ ctx[7].description) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(td0, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*$basketStore*/ 2 && t3_value !== (t3_value = (/*item*/ ctx[7].book_type == 'PRINT'
			? 'tištěná'
			: 'ekniha') + "")) set_data_dev(t3, t3_value);

			if (dirty & /*$basketStore*/ 2 && t5_value !== (t5_value = /*item*/ ctx[7].unit_price.toLocaleString() + "")) set_data_dev(t5, t5_value);

			if (dirty & /*$basketStore*/ 2 && input_value_value !== (input_value_value = /*item*/ ctx[7].quantity) && input.value !== input_value_value) {
				prop_dev(input, "value", input_value_value);
			}

			if (dirty & /*$basketStore*/ 2 && t9_value !== (t9_value = /*item*/ ctx[7].full_price.toLocaleString() + "")) set_data_dev(t9, t9_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(tr);
			if (if_block) if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(53:12) {#each $basketStore.items as item}",
		ctx
	});

	return block;
}

// (90:4) {#if $basketQuantity < $basketStore.quantityThreshold && $isDiscountActive && $basketStore.unitDiscount > 0}
function create_if_block_2(ctx) {
	let p;
	let t0;
	let t1_value = /*$basketStore*/ ctx[1].quantityThreshold - /*$basketQuantity*/ ctx[2] + "";
	let t1;
	let t2;
	let t3_value = getBookForm(/*$basketStore*/ ctx[1].quantityThreshold - /*$basketQuantity*/ ctx[2]) + "";
	let t3;
	let t4;
	let b;
	let t5_value = /*$basketStore*/ ctx[1].unitDiscount + "";
	let t5;
	let t6;
	let t7;

	const block = {
		c: function create() {
			p = element("p");
			t0 = text("Vložte do košíku alespoň ještě ");
			t1 = text(t1_value);
			t2 = space();
			t3 = text(t3_value);
			t4 = text(" pro získání ");
			b = element("b");
			t5 = text(t5_value);
			t6 = text(" Kč slevy");
			t7 = text(" za každou knihu ve Vašem košíku!");
			set_style(b, "color", "red");
			add_location(b, file, 90, 165, 3060);
			add_location(p, file, 90, 4, 2899);
		},
		m: function mount(target, anchor) {
			insert_dev(target, p, anchor);
			append_dev(p, t0);
			append_dev(p, t1);
			append_dev(p, t2);
			append_dev(p, t3);
			append_dev(p, t4);
			append_dev(p, b);
			append_dev(b, t5);
			append_dev(b, t6);
			append_dev(p, t7);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketStore, $basketQuantity*/ 6 && t1_value !== (t1_value = /*$basketStore*/ ctx[1].quantityThreshold - /*$basketQuantity*/ ctx[2] + "")) set_data_dev(t1, t1_value);
			if (dirty & /*$basketStore, $basketQuantity*/ 6 && t3_value !== (t3_value = getBookForm(/*$basketStore*/ ctx[1].quantityThreshold - /*$basketQuantity*/ ctx[2]) + "")) set_data_dev(t3, t3_value);
			if (dirty & /*$basketStore*/ 2 && t5_value !== (t5_value = /*$basketStore*/ ctx[1].unitDiscount + "")) set_data_dev(t5, t5_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(p);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(90:4) {#if $basketQuantity < $basketStore.quantityThreshold && $isDiscountActive && $basketStore.unitDiscount > 0}",
		ctx
	});

	return block;
}

// (94:4) {#if $basketQuantity >= $basketStore.quantityThreshold && $isDiscountActive && $basketStore.unitDiscount > 0}
function create_if_block_1(ctx) {
	let p;
	let t0;
	let t1_value = /*$basketStore*/ ctx[1].quantityThreshold + "";
	let t1;
	let t2;
	let t3_value = getBookForm(/*$basketStore*/ ctx[1].quantityThreshold) + "";
	let t3;
	let t4;
	let b;
	let t5;
	let t6;
	let t7;

	const block = {
		c: function create() {
			p = element("p");
			t0 = text("Hurá! Protože máte v košíku alespoň ");
			t1 = text(t1_value);
			t2 = space();
			t3 = text(t3_value);
			t4 = text(", máte slevu celkem ");
			b = element("b");
			t5 = text(/*$basketDiscount*/ ctx[4]);
			t6 = text(" kč");
			t7 = text("!");
			set_style(b, "color", "red");
			add_location(b, file, 94, 141, 3426);
			add_location(p, file, 94, 4, 3289);
		},
		m: function mount(target, anchor) {
			insert_dev(target, p, anchor);
			append_dev(p, t0);
			append_dev(p, t1);
			append_dev(p, t2);
			append_dev(p, t3);
			append_dev(p, t4);
			append_dev(p, b);
			append_dev(b, t5);
			append_dev(b, t6);
			append_dev(p, t7);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*$basketStore*/ 2 && t1_value !== (t1_value = /*$basketStore*/ ctx[1].quantityThreshold + "")) set_data_dev(t1, t1_value);
			if (dirty & /*$basketStore*/ 2 && t3_value !== (t3_value = getBookForm(/*$basketStore*/ ctx[1].quantityThreshold) + "")) set_data_dev(t3, t3_value);
			if (dirty & /*$basketDiscount*/ 16) set_data_dev(t5, /*$basketDiscount*/ ctx[4]);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(p);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(94:4) {#if $basketQuantity >= $basketStore.quantityThreshold && $isDiscountActive && $basketStore.unitDiscount > 0}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div1;
	let h1;
	let img;
	let img_src_value;
	let t0;
	let t1;
	let div0;
	let t3;

	function select_block_type(ctx, dirty) {
		if (/*$basketItemsCount*/ ctx[0] > 0) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	const block = {
		c: function create() {
			div1 = element("div");
			h1 = element("h1");
			img = element("img");
			t0 = text("\n    Košík");
			t1 = space();
			div0 = element("div");
			div0.textContent = "Všechny ceny jsou vč. DPH";
			t3 = space();
			if_block.c();
			if (!src_url_equal(img.src, img_src_value = basketImage)) attr_dev(img, "src", img_src_value);
			attr_dev(img, "alt", "Košík");
			add_location(img, file, 29, 4, 785);
			add_location(h1, file, 28, 0, 776);
			attr_dev(div0, "class", "basketInfoVat");
			add_location(div0, file, 33, 0, 840);
			attr_dev(div1, "class", "container basket");
			add_location(div1, file, 26, 0, 744);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div1, anchor);
			append_dev(div1, h1);
			append_dev(h1, img);
			append_dev(h1, t0);
			append_dev(div1, t1);
			append_dev(div1, div0);
			append_dev(div1, t3);
			if_block.m(div1, null);
		},
		p: function update(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div1, null);
				}
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div1);
			if_block.d();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function getBookForm(number) {
	// Convert to absolute number if negative
	const absNumber = Math.abs(number);

	// Handle special case for 1
	if (absNumber === 1) return "knihu";

	// Handle numbers 2-4
	if (absNumber >= 2 && absNumber <= 4) return "knihy";

	// Handle all other cases (0, 5 and more)
	return "knih";
}

function instance($$self, $$props, $$invalidate) {
	let $basketItemsCount;
	let $basketStore;
	let $basketQuantity;
	let $isDiscountActive;
	let $basketDiscount;
	validate_store(basketItemsCount, 'basketItemsCount');
	component_subscribe($$self, basketItemsCount, $$value => $$invalidate(0, $basketItemsCount = $$value));
	validate_store(basketStore, 'basketStore');
	component_subscribe($$self, basketStore, $$value => $$invalidate(1, $basketStore = $$value));
	validate_store(basketQuantity, 'basketQuantity');
	component_subscribe($$self, basketQuantity, $$value => $$invalidate(2, $basketQuantity = $$value));
	validate_store(isDiscountActive, 'isDiscountActive');
	component_subscribe($$self, isDiscountActive, $$value => $$invalidate(3, $isDiscountActive = $$value));
	validate_store(basketDiscount, 'basketDiscount');
	component_subscribe($$self, basketDiscount, $$value => $$invalidate(4, $basketDiscount = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Basket', slots, []);
	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Basket> was created with unknown prop '${key}'`);
	});

	const change_handler = (item, e) => basketStore.setProductQuantity(item.book, item.book_type, e.target.value);
	const click_handler = item => basketStore.removeProduct(item.book, item.book_type);

	$$self.$capture_state = () => ({
		basketStore,
		basketItemsCount,
		basketPrice,
		basketQuantity,
		basketDiscount,
		isDiscountActive,
		basketImage,
		getBookForm,
		$basketItemsCount,
		$basketStore,
		$basketQuantity,
		$isDiscountActive,
		$basketDiscount
	});

	return [
		$basketItemsCount,
		$basketStore,
		$basketQuantity,
		$isDiscountActive,
		$basketDiscount,
		change_handler,
		click_handler
	];
}

class Basket extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Basket",
			options,
			id: create_fragment.name
		});
	}
}

export default Basket;